import { getIsMacOs } from 'shared/utils/get-is-mac-os';

export const getPlatformShortcut = (keys: string[]): string[] => {
  return keys.map((key) => {
    const keyLower = key.toLowerCase();

    // Handle Modifier (Command on Mac, Ctrl on Windows)
    if (keyLower === 'mod') {
      return getIsMacOs() ? '⌘' : 'Ctrl';
    }

    // Handle Control (Ctrl on Mac (control symbol), Ctrl on Windows)
    if (keyLower === 'control' || keyLower === 'ctrl') {
      return getIsMacOs() ? '⌃' : 'Ctrl';
    }

    // Handle Alt/Option
    if (keyLower === 'alt' || keyLower === 'option') {
      return getIsMacOs() ? '⌥' : 'Alt';
    }

    // Handle Shift
    if (keyLower === 'shift') {
      return getIsMacOs() ? '⇧' : 'Shift';
    }

    // Handle Meta/Command/Windows
    if (
      keyLower === 'meta' ||
      keyLower === 'cmd' ||
      keyLower === 'command' ||
      keyLower === 'win'
    ) {
      return getIsMacOs() ? '⌘' : 'Win';
    }

    // Return other keys capitalized or as is
    return key.length === 1 ? key.toUpperCase() : key;
  });
};
